import { render, staticRenderFns } from "./SiryoDownload.vue?vue&type=template&id=2a643a89&scoped=true&"
import script from "./SiryoDownload.vue?vue&type=script&lang=js&"
export * from "./SiryoDownload.vue?vue&type=script&lang=js&"
import style0 from "./SiryoDownload.vue?vue&type=style&index=0&id=2a643a89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a643a89",
  null
  
)

export default component.exports